// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"step-card_wrapper__v77Ec","image":"step-card_image__bO2gz","content":"step-card_content__BEbtH","step":"step-card_step__PRUQ5","text":"step-card_text__a9rtm"};